import { render, staticRenderFns } from "./DataCurrentUser.vue?vue&type=template&id=be39c584&"
import script from "./DataCurrentUser.vue?vue&type=script&lang=ts&"
export * from "./DataCurrentUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports